import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Eye, UtensilsCrossed, CalendarCheck, Phone, MapPin, Star, CalendarDays, Users, Mail, Instagram } from "lucide-react";

const LABELS = {
  page_view: { label: "Visite pagine", icon: Eye },
  menu_view: { label: "Visualizzazioni menù", icon: UtensilsCrossed },
  book_click: { label: "Click su Prenota", icon: CalendarCheck },
  book_submit: { label: "Prenotazioni inviate", icon: CalendarCheck },
  call_click: { label: "Click su Chiama", icon: Phone },
  maps_click: { label: "Click su Google Maps", icon: MapPin },
  review_click: { label: "Click recensione Google", icon: Star },
  event_view: { label: "Visualizzazioni eventi", icon: CalendarDays },
  group_request: { label: "Richieste aziendali", icon: Users },
  newsletter_signup: { label: "Iscrizioni newsletter", icon: Mail },
  instagram_click: { label: "Click Instagram", icon: Instagram },
};

export default function AnalyticsView() {
  const [data, setData] = useState({ totals: {} });
  useEffect(() => { api.get("/analytics").then((r) => setData(r.data)).catch(() => {}); }, []);
  const totals = data.totals || {};
  const keys = Object.keys(LABELS);

  return (
    <div>
      <h2 className="font-serif text-2xl text-bordeaux mb-4">Analytics</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {keys.map((k) => {
          const cfg = LABELS[k]; const Icon = cfg.icon;
          return (
            <div key={k} className="bg-white rounded-xl border border-brass/15 p-4" data-testid={`analytics-${k}`}>
              <Icon className="w-5 h-5 text-brass mb-2" />
              <div className="font-serif text-3xl text-bordeaux">{totals[k] || 0}</div>
              <div className="text-xs text-oak/60 mt-1">{cfg.label}</div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-oak/40 mt-4">I dati misurano le azioni compiute dai visitatori del sito.</p>
    </div>
  );
}
